export const kpiMetricsStoreKey = 'kpiMetrics';
